module.exports = __webpack_public_path__ + "static/media/final-j-171-bet-el-watan-shot-3.6e87b3cb.webp";